import * as React from "react";
import { SVGProps, memo } from "react";

const SvgSms = (props: SVGProps<SVGSVGElement>) => (
  <svg width={48} height={51} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#SMS_svg__a)">
      <rect y={18.333} width={48} height={32.667} rx={4} fill="#E7F4FD" />

      <path
        opacity={0.5}
        d="M46.151 45.737c1.152.735 1.975 2.094 1.285 3.272C46.737 50.202 45.46 51 44 51H4c-1.46 0-2.737-.798-3.436-1.99-.69-1.18.133-2.538 1.285-3.273L24 31.604l22.151 14.133Z"
        fill="#A1D5F7"
      />

      <path
        d="M1.849 23.596C.697 22.861-.126 21.503.564 20.324c.699-1.192 1.976-1.99 3.436-1.99h40c1.46 0 2.737.798 3.436 1.99.69 1.179-.133 2.537-1.285 3.272L24 37.73 1.849 23.596Z"
        fill="#fff"
      />

      <rect
        x={0.8}
        y={19.133}
        width={46.4}
        height={31.067}
        rx={3.2}
        stroke="#2B323B"
        strokeWidth={1.6}
        strokeLinecap="round"
      />
    </g>

    <path
      d="m1 22.417 23 15.312 23-15.312"
      stroke="#2B323B"
      strokeWidth={1.6}
      strokeLinecap="round"
    />

    <path
      d="m10.11 11.348 2.088-.204c.047.492.12.72.323.972.324.42.888.648 1.596.648 1.044 0 1.704-.48 1.704-1.248 0-.372-.155-.672-.467-.864-.372-.24-.744-.36-2.052-.66-1.02-.24-1.416-.396-1.872-.72-.672-.504-1.032-1.236-1.032-2.124 0-1.764 1.404-2.88 3.623-2.88 1.428 0 2.508.432 3.133 1.248.3.408.456.756.611 1.464l-2.112.228c-.06-.372-.144-.552-.312-.768-.275-.324-.755-.504-1.332-.504-.936 0-1.56.456-1.56 1.14a.93.93 0 0 0 .409.78c.263.168.503.252 1.127.396 1.309.276 1.885.432 2.364.648.492.216.936.588 1.212 1.044.24.396.36.876.36 1.452 0 1.956-1.367 3.072-3.768 3.072-1.548 0-2.712-.432-3.348-1.236-.396-.492-.563-.948-.695-1.884Zm15.767 2.904h-1.752c-.06-.408-.228-.972-.516-1.692l-1.464-3.732c-.144-.372-.312-.924-.564-1.824.072 1.164.096 1.644.096 1.944v3.492c0 .84.024 1.332.096 1.812h-2.004c.072-.504.096-.996.096-1.812V6.32c0-.756-.024-1.32-.096-1.824h2.664c.072.444.216.948.444 1.548l2.136 5.592 2.124-5.592c.24-.612.372-1.092.444-1.548h2.664c-.072.576-.096 1.02-.096 1.824v6.12c0 .9.024 1.356.096 1.812H28.24c.072-.54.096-.972.096-1.812V8.912c0-.288.024-.768.096-1.908-.06.228-.06.228-.192.756-.06.204-.264.852-.336 1.032l-1.512 3.78c-.24.624-.456 1.296-.516 1.68Zm6.162-2.904 2.088-.204c.048.492.12.72.324.972.324.42.888.648 1.596.648 1.044 0 1.704-.48 1.704-1.248 0-.372-.156-.672-.468-.864-.372-.24-.744-.36-2.052-.66-1.02-.24-1.416-.396-1.872-.72-.672-.504-1.032-1.236-1.032-2.124 0-1.764 1.404-2.88 3.624-2.88 1.428 0 2.508.432 3.132 1.248.3.408.456.756.612 1.464l-2.112.228c-.06-.372-.144-.552-.312-.768-.276-.324-.756-.504-1.332-.504-.936 0-1.56.456-1.56 1.14a.93.93 0 0 0 .408.78c.264.168.504.252 1.128.396 1.308.276 1.884.432 2.364.648.492.216.936.588 1.212 1.044.24.396.36.876.36 1.452 0 1.956-1.368 3.072-3.768 3.072-1.548 0-2.712-.432-3.348-1.236-.396-.492-.564-.948-.696-1.884Z"
      fill="#0F72BD"
    />

    <defs>
      <clipPath id="SMS_svg__a">
        <path fill="#fff" transform="translate(0 18.333)" d="M0 0h48v32.667H0z" />
      </clipPath>
    </defs>
  </svg>
);

const Memo = memo(SvgSms);

export default Memo;
